import styled from 'styled-components'

export const SettingsContainer = styled.div`
    position: relative;
    width: 100%;
    height: calc(100vh - 71px);

    .settings-header-wrapper {
        background: var(--gray-200);
        height: 40px;

        .settings-header {
            display: flex;
            align-items: center;
            flex-direction: row;
            height: 40px;
            gap: 20px;
            padding: 0;

            .settings-header-item {
                padding: 10px 0;
                color: var(--blue-500);
                font-family: var(--font-bold);
                border-bottom: 2px solid var(--gray-200);
                cursor: pointer;

                &.active {
                    color: var(--gray-700);
                    border-bottom: 2px solid var(--blue-500);
                }
            }
        }
    }

    /* .settings-lists-wrapper {
        .settings-lists {
            margin-top: 15px;
        }
    } */
`
